import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  connectedInCV(){
    return this.getCongresConUser() ? true : false;
  }

  connectedManagerInCV(){
    return this.getManagerCon() ? true : false;
  }

  setCongresConUser(user){
    localStorage.setItem("_congrescouser", btoa(JSON.stringify(user)));
  }

  getCongresConUser() {
    return localStorage.getItem("_congrescouser") ? JSON.parse(atob(localStorage.getItem("_congrescouser"))) : null;
  }

  removeCongresConUser(){
    localStorage.removeItem("_congrescouser");
  }

  getManagerCon(){
    return localStorage.getItem("manager-code") ? localStorage.getItem("manager-code") : null;
  }
}
